import { cn } from "@/lib/utils";


type EvBadgeVariant = "default" | "pill";
type EvBadgeSize = "sm" | "md";
type EvBadgeTone = "value" | "muted" | "loss";

const VARIANT_STYLES: Record<EvBadgeVariant, string> = {
  default: "rounded px-2 font-semibold",
  pill: "rounded-full px-2.5 font-bold",
};

const SIZE_STYLES: Record<EvBadgeSize, string> = {
  sm: "py-1 text-[11px]",
  md: "py-1.5 text-[13px]",
};

const TONE_STYLES: Record<EvBadgeTone, string> = {
  value: "border border-accent-value/30 bg-accent-value/20 text-accent-value",
  muted: "border border-white/10 bg-white/[0.06] text-zinc-300",
  loss: "border border-destructive/30 bg-destructive/20 text-destructive",
};

interface EvBadgeProps {
  value: number;
  variant?: EvBadgeVariant;
  size?: EvBadgeSize;
  tone?: EvBadgeTone;
  decimals?: number;
  className?: string;
}

export function EvBadge({
  value,
  variant = "default",
  size = "sm",
  tone,
  decimals = 2,
  className,
}: EvBadgeProps) {
  const positive = value >= 0;
  const colorClass = tone ? TONE_STYLES[tone] : positive ? TONE_STYLES.value : TONE_STYLES.loss;

  return (
    <span
      className={cn(
        "inline-flex items-center data-num tabular-nums",
        SIZE_STYLES[size],
        VARIANT_STYLES[variant],
        colorClass,
        "leading-none",
        className,
      )}
    >
      {positive ? "+" : ""}
      {value.toFixed(decimals)}%
    </span>
  );
}
